import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Plus } from 'lucide-react'
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Textarea } from "@/components/ui/textarea"
import { format } from 'date-fns'

const ImportNoteDialog = ({ onSubmit, isImporting, result, onClose }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [noteInput, setNoteInput] = useState({
        date: format(new Date(), 'yyyy-MM-dd'),
        reason: '',
    })

    const handleSubmit = async () => {
        await onSubmit(noteInput)
    }

    const handleClose = () => {
        setIsOpen(false)
        setNoteInput({
            date: format(new Date(), 'yyyy-MM-dd'),
            reason: '',
        })
        onClose()
    }

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <Button variant="outline">
                    <Plus className="mr-2 h-4 w-4" />
                    Import Notes
                </Button>
            </DialogTrigger>
            <DialogContent onCloseAutoFocus={handleClose}>
                <DialogHeader>
                    <DialogTitle>Import Notes</DialogTitle>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    <div className="grid grid-cols-4 items-center gap-4">
                        <Label htmlFor="date" className="text-right">
                            Date
                        </Label>
                        <Input
                            id="date"
                            type="date"
                            value={noteInput.date}
                            onChange={(e) => setNoteInput(prev => ({ ...prev, date: e.target.value }))}
                            className="col-span-3"
                        />
                    </div>
                    <div className="grid grid-cols-4 items-center gap-4">
                        <Label htmlFor="reason" className="text-right">
                            Content
                        </Label>
                        {result.successNotes.length > 0 || result.failedNotes.length > 0 ? (
                            <div className="col-span-3 space-y-2 h-[200px] overflow-y-auto overflow-x-auto">
                                {result.failedNotes?.length > 0 && (
                                    <div>
                                        <h4 className="font-medium text-destructive">导入失败:</h4>
                                        <ul className="list-disc pl-4">
                                            {result.failedNotes.map((note, index) => (
                                                <li key={index} className="text-destructive whitespace-nowrap">
                                                    {note.valid === 1 ? '无法识别campaign ID' : '日期不匹配'} - {note.content}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                                {result.successNotes?.length > 0 && (
                                    <div>
                                        <h4 className="font-medium">导入成功:</h4>
                                        <ul className="list-disc pl-4">
                                            {result.successNotes.map((note, index) => (
                                                <li key={index} className="whitespace-nowrap">
                                                    {note.date} - {note.campaignId} - {note.reason}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </div>
                        ) : (
                                <Textarea
                                    id="reason"
                                    value={noteInput.reason}
                                    onChange={(e) => setNoteInput(prev => ({ ...prev, reason: e.target.value }))}
                                    className="col-span-3"
                                    rows={8}
                                    placeholder="请粘贴记录内容"
                                    disabled={isImporting}
                                />
                        )}
                    </div>
                </div>
                <div className="flex justify-end gap-2">
                    <Button
                        variant="outline"
                        onClick={() => {
                            handleClose()
                        }}
                    >
                        关闭
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        disabled={isImporting || !noteInput.date || !noteInput.reason}
                    >
                        {isImporting ? '导入中...' : '导入'}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default ImportNoteDialog 